export const findFirstTileTextNodeById = (response, nodeId) => {
  return response.find((node) => {
    return node.status === 200 && node.body?.meta_data?.source === nodeId;
  });
};
